// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .mat-button .mat-button-focus-overlay {
  background-color: transparent;
}
:host .dlg-container {
  position: relative;
  height: 600px;
}
:host .separator {
  align-items: center;
  display: flex;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}
:host .separator-line {
  border-bottom: 1px solid var(--setupSeparatorColor);
  height: 1px;
  width: 35%;
}
:host .separator-text {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 13px;
}
:host .btn-cards {
  display: flex;
  flex-wrap: wrap;
  margin-left: -8px;
  margin-right: -8px;
  margin-top: 16px;
  margin-bottom: 18px;
  justify-content: center;
}
:host .btn-card {
  margin-left: 3px;
  margin-right: 3px;
  padding-left: 4px;
  padding-right: 4px;
  flex: 1;
}
:host .card-btn {
  height: 85px;
  min-height: auto;
  min-width: 100px;
  width: 100px;
  font-size: 16px;
  text-align: center;
  align-content: center;
  overflow: hidden;
  padding: 0px !important;
}
:host .card-btn span {
  display: block;
  font-weight: normal !important;
  font-size: 13px;
  text-align: center;
}
:host .card-btn-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0 5px 0;
  text-align: center;
  height: 100%;
}
:host .card-btn-content .mat-icon {
  font-size: 32px;
  margin-bottom: 6px;
  height: 32px;
  width: 32px;
}
:host .card-btn-content span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: center;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  min-height: 2.4em;
  max-height: 2.4em;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/setup/setup.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/setup/setup.component.scss"],"names":[],"mappings":"AACI;EACI,6BAAA;ACAR;ADGI;EACI,kBAAA;EAEA,aAAA;ACFR;ADKI;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACHR;ADMI;EACI,mDAAA;EACA,WAAA;EACA,UAAA;ACJR;ADOI;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;ACLR;ADQI;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACNR;ADSI;EAEI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;ACRR;ADWI;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAEA,qBAAA;EACA,gBAAA;EACA,uBAAA;ACTR;ADYI;EACI,cAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;ACVR;ADaI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;ACXR;ADcI;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;ACZR;ADeI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ACbR","sourcesContent":[":host {\n    .mat-button .mat-button-focus-overlay {\n        background-color: transparent;\n    }\n\n    .dlg-container {\n        position: relative;\n        // width: 300px;\n        height: 600px;\n    }\n\n    .separator {\n        align-items: center;\n        display: flex;\n        position: relative;\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n    .separator-line {\n        border-bottom: 1px solid var(--setupSeparatorColor);\n        height: 1px;\n        width: 35%;\n    }\n\n    .separator-text {\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        font-size: 13px;\n    }\n\n    .btn-cards {\n        display: flex;\n        flex-wrap: wrap;\n        margin-left: -8px;\n        margin-right: -8px;\n        margin-top: 16px;\n        margin-bottom: 18px;\n        justify-content: center;\n    }\n\n    .btn-card {\n        // flex-basis: 25%;\n        margin-left: 3px;\n        margin-right: 3px;\n        padding-left: 4px;\n        padding-right: 4px;\n        flex: 1;\n    }\n\n    .card-btn {\n        height: 85px;\n        min-height: auto;\n        min-width: 100px;\n        width: 100px;\n        font-size: 16px;\n        text-align: center;\n        -webkit-align-content: center;\n        align-content: center;\n        overflow: hidden;\n        padding: 0px !important;\n    }\n\n    .card-btn span {\n        display: block;\n        font-weight: normal !important;\n        font-size: 13px;\n        text-align: center;\n    }\n\n    .card-btn-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 10px 0 5px 0;\n        text-align: center;\n        height: 100%;\n    }\n\n    .card-btn-content .mat-icon {\n        font-size: 32px;\n        margin-bottom: 6px;\n        height: 32px;\n        width: 32px;\n    }\n\n    .card-btn-content span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        text-align: center;\n        white-space: normal;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        line-height: 1.2;\n        min-height: 2.4em;\n        max-height: 2.4em;\n        padding: 0 4px;\n    }\n}",":host .mat-button .mat-button-focus-overlay {\n  background-color: transparent;\n}\n:host .dlg-container {\n  position: relative;\n  height: 600px;\n}\n:host .separator {\n  align-items: center;\n  display: flex;\n  position: relative;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n:host .separator-line {\n  border-bottom: 1px solid var(--setupSeparatorColor);\n  height: 1px;\n  width: 35%;\n}\n:host .separator-text {\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 13px;\n}\n:host .btn-cards {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -8px;\n  margin-right: -8px;\n  margin-top: 16px;\n  margin-bottom: 18px;\n  justify-content: center;\n}\n:host .btn-card {\n  margin-left: 3px;\n  margin-right: 3px;\n  padding-left: 4px;\n  padding-right: 4px;\n  flex: 1;\n}\n:host .card-btn {\n  height: 85px;\n  min-height: auto;\n  min-width: 100px;\n  width: 100px;\n  font-size: 16px;\n  text-align: center;\n  -webkit-align-content: center;\n  align-content: center;\n  overflow: hidden;\n  padding: 0px !important;\n}\n:host .card-btn span {\n  display: block;\n  font-weight: normal !important;\n  font-size: 13px;\n  text-align: center;\n}\n:host .card-btn-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 0 5px 0;\n  text-align: center;\n  height: 100%;\n}\n:host .card-btn-content .mat-icon {\n  font-size: 32px;\n  margin-bottom: 6px;\n  height: 32px;\n  width: 32px;\n}\n:host .card-btn-content span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  text-align: center;\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n  min-height: 2.4em;\n  max-height: 2.4em;\n  padding: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
